module.exports = __webpack_public_path__ + "static/media/example1_after.2d4bde3f.png";